<div class="template3 personal-info">
    <div *ngIf="displayPersonalInfoForm" [class.hideValidation]="validationMessageInitialHide">
        <json-schema-form [widgets]="customWidgets" [framework]="selectedFrameWork" [form]="jsonFormObject" [options]="jsonFormOptions" (onChanges)="onChanges($event)" (valueChanges)="changeInputValue($event)"
            (onSubmit)="savePersonalInfo($event)" (valueChanges)="changeInputValue($event)">
        </json-schema-form>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/enrollment/personal-schema-info.component.html